import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface TooltipProps {
  province: string
}

const Tooltip: React.FC<TooltipProps> = ({ province }) => {
  const { t } = useTranslation()
  const [position, setPosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      setPosition({ x: event.pageX, y: event.pageY })
    }

    window.addEventListener('mousemove', handleMouseMove)
    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])

  return (
    <div
      style={{
        position: 'absolute',
        top: `${position.y - 40}px`,
        left: `${position.x}px`,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        color: 'white',
        padding: '5px 10px',
        borderRadius: '5px',
        pointerEvents: 'none',
        zIndex: 1000,
        transform: 'translateX(-50%)',
      }}
    >
      {t(`provinces.${province}`)}
    </div>
  )
}

export default Tooltip
